"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStoredLabsId = setStoredLabsId;
exports.getStoredLabsId = getStoredLabsId;

var _cookieHelper = require("../lib/cookieHelper");

var _getPreferredUserId = _interopRequireDefault(require("../lib/getPreferredUserId"));

var LABS_LOCAL_ID = 'LocalSettings:Sales:LID';
var LABS_COOKIE_ID = '__hssluid';

function setStoredLabsId() {
  var labsId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  (0, _cookieHelper.setCookie)(LABS_COOKIE_ID, labsId);

  try {
    if (window.localStorage) {
      window.localStorage[LABS_LOCAL_ID] = labsId;
    }
  } catch (e) {
    /* do nothing */
  }

  return labsId;
}

function getStoredLabsId() {
  var labsId;

  try {
    labsId = window.localStorage[LABS_LOCAL_ID];
  } catch (e) {
    labsId = (0, _cookieHelper.getCookie)(LABS_COOKIE_ID);
  }

  if (!labsId) {
    labsId = setStoredLabsId((0, _getPreferredUserId.default)());
  }

  return labsId;
}